import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import {SkillsDto } from './skills.dto';


export class AllSkillsResponseModel extends GlobalResponseObject{
    data?:SkillsDto[];

    /**
     * 
     * @param status 
     * @param intlCode 
     * @param internalMessage 
     * @param data 
     */
     constructor(status:boolean, intlCode:number, internalMessage:string, data?:SkillsDto[]){
        super(status,intlCode,internalMessage);
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
    }
}